import React from 'react';
import video from './video.mp4';
import css from './VideoSection.module.css';

const VideoSection = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.subWrapper}>
        <div className={css.left}>
          <p className={css.title}>
            The power of
            <br /> scan data.
          </p>

          <p className={css.description}>
            Watch our reel to see creators in action <br /> and scans brought to life.
          </p>
        </div>
        <div className={css.right}>
          <video
            playsInline
            width="100%"
            style={{ objectFit: 'cover' }}
            autoPlay
            muted
            loop
            preload="auto"
            controls
          >
            <source src={video} type="video/mp4" />
            Sorry, your browser doesn't support embedded videos.
          </video>
        </div>
      </div>{' '}
    </div>
  );
};

export default VideoSection;
